import { connect } from 'react-redux';
import { UniversalSearch } from '../universalSearch';
import * as ComponentStateActions from '../actions/componentStateActions';

export const mapStateToProps = ({ universalSearch }) => {
    return {
        textBoxFocused: universalSearch.componentState.textBoxFocused,
        inputString: universalSearch.componentState.inputString,
        currentSearchQuery: universalSearch.componentState.currentSearchQuery,
        focusIndex: universalSearch.componentState.focusIndex,
        firstSection: universalSearch.componentState.firstSection,
        secondSection: universalSearch.componentState.secondSection,
        thirdSection: universalSearch.componentState.thirdSection,
        latitude: universalSearch.location.latitude,
        longitude: universalSearch.location.longitude,
    };
};

export const mapDispatchToProps = {
    ...ComponentStateActions,
};

export const UniversalSearchConnector = connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
)(UniversalSearch);
